import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Stack, Typography, useTheme } from '@mui/material';

import { useShallow } from 'zustand/react/shallow';

import { AdvertisingPackageResponse, SpaceResponse } from '@/api/data-contracts';
import useGeneratikTableStore from '@/shared/ui/GeneratikTable/generatikTableStore';
import PriceText from '@/shared/ui/PriceText';

const ShoppingCartTotal: FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { selectedSpaces, selectedPackages } = useGeneratikTableStore(
    useShallow((state) => ({
      selectedSpaces: (state.selectedRows['ADVERTISING_SPACES'] ?? []) as (SpaceResponse & {
        cartPrice?: number;
      })[],
      selectedPackages: (state.selectedRows['ADVERTISING_PACKAGES'] ??
        []) as (AdvertisingPackageResponse & {
        cartPrice?: number;
      })[],
    })),
  );

  return (
    <Stack direction="row" alignItems="flex-end" justifyContent="flex-end" gap="0.3rem">
      <Typography sx={{ fontSize: '0.85rem', lineHeight: 1, color: theme.palette.grey[500] }}>
        {t('Total')}:
      </Typography>

      <Typography sx={{ fontSize: '1rem', lineHeight: 1, color: theme.palette.accent.main }}>
        <PriceText
          price={
            (selectedSpaces?.reduce(
              (sum, row) => sum + (row.cartPrice ?? (row.price || row.pricing?.monthPricing || 0)),
              0,
            ) ?? 0) +
            (selectedPackages?.reduce(
              (sum, row) => sum + (row.cartPrice ?? (row.price || row.pricing?.monthPricing || 0)),
              0,
            ) ?? 0)
          }
        />
      </Typography>
    </Stack>
  );
};

export default ShoppingCartTotal;
